import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { Switch, Route, Redirect } from 'react-router-dom'
// creates a beautiful scrollbar
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'

// core components
import Header from 'components/Header/Header.jsx'
import Footer from 'components/Footer/Footer.jsx'
import Sidebar from 'components/Sidebar/Sidebar.jsx'

import dashboardRoutes, { hiddenRoutes } from 'routes/dashboard'

import appStyle from 'assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.jsx'

import image from 'assets/img/sidebar-2.jpg'
import logo from 'assets/img/logo-white.svg'

import AppContext from '../services/context'
import { GeneralData } from 'staticConfig.js'
import { filter, isEmpty } from 'lodash'
import dashRoutes from '../routes/dashboard'
import { retrieveDataUsingGraphQL } from '../services/generalServiceAPI'
import { logger } from '../views/utility/utility'

const {
  sideBar: { logoText, badgeTimer },
} = GeneralData

const numberOfApplications = (userId, scope, status, cb) => {
  /*
    Make a general function to query the number of records
  */
  const getApplication = `
    query Application($userId: ID!, $scope: String!, $status: String, $onlyGetCount: Boolean) {
      applications(userId: $userId, scope: $scope, status: $status, onlyGetCount:$onlyGetCount) {
        totalNumberOfApplications
      }
    }
  `
  retrieveDataUsingGraphQL(getApplication, { userId, scope, status, onlyGetCount: true })
    .then((response) => {
      if (response.ok) {
        return response.json()
      } else {
        logger('[LayOutDashboard][fetchApplications]:', { response }, true)
      }
    })
    .then(({ data }) => {
      const { applications } = data
      //cb({ name: scope, number: isEmpty(applications) ? 0 : applications.length })
      cb(applications['totalNumberOfApplications'])
      return applications['totalNumberOfApplications']
    })
    .catch((error) => logger('[LayOutDashboard][fetchApplications]:', error, true))
}
// This will only be loaded once when imported
// They key for each route WILL be duplicated - subroute will have same ID as the parent

const reduceRoutes = (userRole) => {
  return filter(dashboardRoutes, (route) => {
    return route.forWhom.includes(userRole)
  })
}
// hiddenRoutes contains those which shouldn't appear in sideBar but still routebale
// spread them so they could be in the same array, it may not matter tho
// add 100 on the key of hiddenRoutes to remove conflicting
const combineRoutes = (userRole) => {
  let loop = 0
  return [
    ...hiddenRoutes.map((prop, key) => {
      loop++
      if (prop.redirect) {
        return <Redirect from={prop.path} to={prop.pathTo} key={key + 100} />
      }
      if (prop.collapse)
        return prop.views.map((prop, key) => {
          return prop.render ? (
            <Route path={prop.path} render={prop.render} key={key + loop * 200} />
          ) : (
            <Route path={prop.path} component={prop.component} key={key + loop * 200} />
          )
        })
      return prop.render ? (
        <Route path={prop.path} render={prop.render} key={key + 100} />
      ) : (
        <Route path={prop.path} component={prop.component} key={key + 100} />
      )
    }),
    ...reduceRoutes(userRole).map((prop, key) => {
      loop++
      if (prop.redirect) {
        return <Redirect from={prop.path} to={prop.pathTo} key={key} />
      }
      if (prop.collapse)
        return prop.views.map((prop, key) => {
          // return <Route path={prop.path} component={prop.component} key={key} />
          return prop.render ? (
            <Route path={prop.path} render={prop.render} key={key + loop * 200} />
          ) : (
            <Route path={prop.path} component={prop.component} key={key + loop * 200} />
          )
        })
      return prop.render ? <Route path={prop.path} render={prop.render} key={key} /> : <Route path={prop.path} component={prop.component} key={key} />
    }),
  ]
}
const switchRoutes = (roleID) => <Switch>{combineRoutes(roleID)}</Switch>
// console.log(switchRoutes(2))
var ps

class Dashboard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mobileOpen: false,
      miniActive: false,
      refreshTriggeredBySelf: false,
    }
    this.resizeFunction = this.resizeFunction.bind(this)
    this.collectNumbers = this.collectNumbers.bind(this)
    this.pullingNumbers = this.pullingNumbers.bind(this)
  }
  //static contextType = AppContext

  //collectNumbers = (a, name) => value => a[name] = value
  collectNumbers = (name) => (value) =>
    this.setState((prevState, props) => ({
      number: { ...prevState.number, [name]: value },
      refreshTriggeredBySelf: name !== 'completed',
    }))

  componentDidMount() {
    if (navigator.platform.indexOf('Win') > -1) {
      ps = new PerfectScrollbar(this.refs.mainPanel, {
        suppressScrollX: true,
        suppressScrollY: false,
      })
      document.body.style.overflow = 'hidden'
    }
    window.addEventListener('resize', this.resizeFunction)
    // const pullingNumbers = () => {
    //   // console.log('start to pulling numbers')
    //   ++this.state.refreshed
    //   numberOfApplications(this.context.user.id, 'needToSign', 'submitted', this.collectNumbers('needToSign'))
    //   numberOfApplications(this.context.user.id, 'requested', 'draft', this.collectNumbers('drafts'))
    //   numberOfApplications(this.context.user.id, 'requested', 'submitted', this.collectNumbers('inprogress'))
    //   numberOfApplications(this.context.user.id, 'requested', 'finished', this.collectNumbers('done'))
    //   numberOfApplications(this.context.user.id, 'waitingForComments', 'submitted', this.collectNumbers('waitingForComments'))
    //   numberOfApplications(this.context.user.id, 'approved', 'submitted', this.collectNumbers('approved'))
    //   numberOfApplications(this.context.user.id, 'rejected', '', this.collectNumbers('rejected'))
    //   numberOfApplications(this.context.user.id, 'related', 'finished', this.collectNumbers('completed'))
    // }
    this.pullingNumbers()
    // console.log('adding pulling number to context')
    this.context.pullingNumbers = this.pullingNumbers
    // console.log(this.context)
    setInterval(this.pullingNumbers, badgeTimer)
    // setInterval(() => { ++this.context.timer }, 1000)
  }

  /* 我太牛x了， 为了这个能正常工作
    1. collectNumbers 需要 给setState一个函数， 而不是一个对象， 这样可以防止 覆盖， 这是我能想到的最佳的用异步回调更新 component state 的方法
    2. 立即调用 setInterval 函数需要把函数体先放到括号了
  */
  pullingNumbers = () => {
    // console.log('start to pulling numbers')
    this.state.refreshTriggeredBySelf = true
    numberOfApplications(this.context.user.id, 'needToSign', 'submitted', this.collectNumbers('needToSign'))
    numberOfApplications(this.context.user.id, 'requested', 'draft', this.collectNumbers('drafts'))
    numberOfApplications(this.context.user.id, 'requested', 'submitted', this.collectNumbers('inprogress'))
    numberOfApplications(this.context.user.id, 'requested', 'finished', this.collectNumbers('done'))
    numberOfApplications(this.context.user.id, 'waitingForComments', 'submitted', this.collectNumbers('waitingForComments'))
    numberOfApplications(this.context.user.id, 'approved', 'submitted', this.collectNumbers('approved'))
    numberOfApplications(this.context.user.id, 'rejected', '', this.collectNumbers('rejected'))
    numberOfApplications(this.context.user.id, 'related', 'finished', this.collectNumbers('completed'))
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf('Win') > -1) {
      ps.destroy()
    }
    window.removeEventListener('resize', this.resizeFunction)
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false })
      }
    }
  }
  handleDrawerToggle = () => {
    // console.log(this.props.location.pathname)
    this.setState({ mobileOpen: !this.state.mobileOpen })
  }
  getRoute() {
    return this.props.location.pathname !== '/maps/full-screen-maps'
  }
  sidebarMinimize() {
    this.setState({ miniActive: !this.state.miniActive })
  }
  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false })
    }
  }
  render() {
    const { classes, ...rest } = this.props
    const mainPanel =
      classes.mainPanel +
      ' ' +
      cx({
        [classes.mainPanelSidebarMini]: this.state.miniActive,
        [classes.mainPanelWithPerfectScrollbar]: navigator.platform.indexOf('Win') > -1,
      })
    // if (!this.state.refreshTriggeredBySelf) this.pullingNumbers()
    const routes = reduceRoutes(this.context.user.roleID).map((route) => {
      // console.log(isEmpty(this.state.number))
      if (!isEmpty(this.state.number)) {
        //alert('now')
        if (route.collapse) {
          route.views.map((subRoute) => {
            switch (subRoute.name) {
              case 'Drafts':
                subRoute['number'] = this.state.number['drafts']
                break
              case 'In Progress':
                subRoute['number'] = this.state.number['inprogress']
                break
              case 'Completed':
                subRoute['number'] = this.state.number['done']
                break
              default:
            }
          })
        } else {
          switch (route.name) {
            case 'Dashboard':
              route['number'] = this.state.number['needToSign']
              break
            case 'I am Invited':
              route['number'] = this.state.number['waitingForComments']
              break
            case 'I Approved':
              route['number'] = this.state.number['approved']
              break
            case 'I Rejected':
              route['number'] = this.state.number['rejected']
              break
            case 'All Signed':
              route['number'] = this.state.number['completed']
              break

            // case 'All Applications':
            //   route['number'] = n
            default:
          }
        }
      }
      return route
    })
    // console.log(routes)
    return (
      <div className={classes.wrapper}>
        <Sidebar
          userFullName={this.context.user.firstname + ' ' + this.context.user.lastname}
          routes={routes} //dashboardRoutes
          logoText={this.context.user.company && this.context.user.company.short ? this.context.user.company.short : logoText}
          // logoText={jsonPP(this.state.number)}
          logo={logo}
          image={image}
          handleDrawerToggle={this.handleDrawerToggle}
          open={this.state.mobileOpen}
          color='blue'
          bgColor='black'
          miniActive={this.state.miniActive}
          {...rest}
        />
        <div className={mainPanel} ref='mainPanel'>
          <Header
            sidebarMinimize={this.sidebarMinimize.bind(this)}
            miniActive={this.state.miniActive}
            routes={dashRoutes.concat(hiddenRoutes)}
            handleDrawerToggle={this.handleDrawerToggle}
            {...rest}
          />
          {/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
          {this.getRoute() ? (
            <div className={classes.content}>
              <div className={classes.container}>{switchRoutes(this.context.user.roleID)}</div>
            </div>
          ) : (
            <div className={classes.map}>{switchRoutes(this.context.user.roleID)}</div>
          )}

          {this.getRoute() ? <Footer fluid /> : null}
        </div>
      </div>
    )
  }
}
Dashboard.contextType = AppContext
Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(appStyle)(Dashboard)
